// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"9735ed6f","977":"10ea2ffc"}[chunkId] + ".chunk.js";
};